export interface GetPlanJobsLocationsRequest {
    searchParam?: string;
    jobId?: string;
    planId: string;
    pageNumber: number;
    pageSize: number;
  }